import { combineReducers } from 'redux';
import WrapperComponents from '../../components/Wrappers/reduxStore/reducer';

const appReducer = combineReducers({
  WrapperComponents: WrapperComponents
});

const rootReducer = (state, action) => {
  if (action.type === 'LOG_OUT' || action.type === 'RESET_REDUX_DATA') {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
